import React from "react";
import { useContext, useState } from "react";

export default function NotFound() {
  return (
    <div className="bodyBackground">
      <h2>Strona nie została znaleziona</h2>
    </div>
  );
}
